/* eslint-disable max-len */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from "react";
import { classnames, Modal, ModalDialog } from "@culturehq/components";
import { Template } from "chq";
import { useDoor } from "app/hooks";
import { Trans } from "app/utils";
import ChqModalDialog from "components/common/ChqModalDialog";
import Card from "components/stories/video-studio/sidebar/tabs/template/video-card/Card";
import ImageCard from "components/stories/video-studio/sidebar/tabs/template/image-card/Card";

import libraryDefaultTemplates from "./utils/libraryDefaultTemplates.json";
import styles from "./buildertemplates.module.scss";

interface LibraryTemplateProps {
  children: (callback: () => void) => React.ReactNode;
  onSelectedTemplate: (template: any) => void;
}

const LibraryTemplate: React.FC<LibraryTemplateProps> = ({
  children,
  onSelectedTemplate = () => {}
}) => {
  const { open, onOpen, onClose } = useDoor(false);
  const [previewTemplate, setPreviewTemplate] = useState<any | null>(null);
  const [previewImageTemplate, setPreviewImageTemplate] = useState<any | null>(null);

  const handleSelectedTemplate = (template: any) => {
    onSelectedTemplate(template);
    onClose();
  };

  const montageTemplates: Template[] = libraryDefaultTemplates.filter(
    template => template.type === "Montage"
  );
  const videoTemplates: Template[] = libraryDefaultTemplates.filter(
    template => template.type === "Video"
  );
  const imageTemplates: Template[] = libraryDefaultTemplates.filter(
    template => template.type === "Image"
  );

  return (
    <>
      {children(onOpen)}
      {open && (
        <ChqModalDialog onClose={onClose} className={styles["library-modal"]}>
          <ModalDialog.Heading onClose={onClose}>
            <h2>Template Library</h2>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <div className={styles["library-templates"]}>
              <div className={styles["template-row"]}>
                <Trans>Video Templates</Trans>
                <div className={classnames(styles["video-wrapper"], styles["template-wrapper"])}>
                  {videoTemplates.map(template => (
                    <div key={template.value}>
                      <Card
                        key={template.value}
                        template={template}
                        onSelectedTemplate={handleSelectedTemplate}
                        onTrigger={() => setPreviewTemplate(template)}
                        templateLibrary
                      />
                      <div className={styles["template-wrapper-name"]}>
                        <h5>{template.name}</h5>
                        <h6>{template.description}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className={styles["template-row"]}>
                <Trans>Montage Templates</Trans>
                <div className={classnames(styles["montage-wrapper"], styles["template-wrapper"])}>
                  {montageTemplates.map(template => (
                    <div key={template.value}>
                      <Card
                        key={template.value}
                        template={template}
                        onSelectedTemplate={handleSelectedTemplate}
                        onTrigger={() => setPreviewTemplate(template)}
                      />
                      <div
                        className={styles["template-wrapper-name"]}
                      >
                        <h5>{template.name}</h5>
                        <h6>{template.description}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className={styles["template-row"]}>
                <Trans>Image Templates</Trans>
                <div className={classnames(styles["image-wrapper"], styles["template-wrapper"])}>
                  {imageTemplates.map(template => (
                    <div key={template.value}>
                      <ImageCard
                        key={template.value}
                        template={template}
                        onSelectedTemplate={handleSelectedTemplate}
                        onTrigger={() => setPreviewImageTemplate(template)}
                      />
                      <div className={styles["template-wrapper-name"]}>
                        <h5>{template.name}</h5>
                        <h6>{template.description}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
      {previewTemplate && (
        <ChqModalDialog onClose={() => setPreviewTemplate(null)} className={styles["Template-Modal"]}>
          <Modal.Heading onClose={() => setPreviewTemplate(null)}>
            <h2>{previewTemplate?.type} {previewTemplate.name}</h2>
          </Modal.Heading>
          <Modal.Body>
            <div className={styles["Template-Modal__BgImage"]} style={{ backgroundImage: `url(${previewTemplate.posterUrl})` }} />
            <video
              src={previewTemplate.url}
              poster={previewTemplate.posterUrl}
              autoPlay
              controls
              controlsList="nodownload"
              className={styles["Template-Modal__Video"]}
            />
          </Modal.Body>
        </ChqModalDialog>
      )}
      {previewImageTemplate && (
        <ChqModalDialog onClose={() => setPreviewImageTemplate(null)} className={styles["Template-Modal"]}>
          <ModalDialog.Heading onClose={() => setPreviewImageTemplate(null)}>
            <h2>{previewTemplate?.type} {previewImageTemplate.name}</h2>
          </ModalDialog.Heading>
          <Modal.Body>
            <div className="Template-BgImage" style={{ backgroundImage: `url(${previewImageTemplate.url})` }} />
            <img
              src={previewImageTemplate.url}
              alt={previewImageTemplate.name}
              className={styles["Template-Modal__Image"]}
            />
          </Modal.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default LibraryTemplate;
